export default __webpack_public_path__ + "static/cruiselines-carnival-activities-2-99dc99bef90a812e17c347650f39009d.jpg";